import { init } from "../init";
import { HomePage } from "../pages/home-page";
init(HomePage);
